export enum OwFGrantApplicationSteps {
  UPSELL = "UPSELL",
  // store details steps
  STORE_DETAILS_INTRO = "STORE_DETAILS_INTRO",
  // financial details steps
  FINANCIAL_DETAILS_INTRO = "FINANCIAL_DETAILS_INTRO",
  STORE_FUNDING_DETAILS = "STORE_FUNDING_DETAILS",
  CREDIT_HISTORY_DETAILS = "CREDIT_HISTORY_DETAILS",
  // video upload steps
  VIDEO_UPLOAD_INTRO = "VIDEO_UPLOAD_INTRO",
  UPLOAD_VIDEO = "UPLOAD_VIDEO",
  REVIEW_VIDEO = "REVIEW_VIDEO",
  PROCESS_VIDEO = "PROCESS_VIDEO",
  // terminal steps
  INELIGIBLE_STORE = "INELIGIBLE_STORE",
  APPLICATION_SUCCESS = "APPLICATION_SUCCESS",
}

enum OwFGrantLandingPageSections {
  HEADER_CARD = "HEADER_CARD",
  DISCLAIMER_CARD = "DISCLAIMER_CARD",
  APPLICATION_INFO_CARD = "APPLICATION_INFO_CARD",
  KEY_DATES_CARD = "KEY_DATES_CARD",
  PAST_WINNERS_CARD = "PAST_WINNERS_CARD",
  LEARN_MORE_CARD = "LEARN_MORE_CARD",
  FAQ_CARD = "FAQ_CARD",
  FOOTER_CARD = "FOOTER_CARD",
}

enum OtherOwFGrantSurfaces {
  SIGN_UP_SOCIAL_MEDIA = "SIGN_UP_SOCIAL_MEDIA",
}

export const OwFGrantFlowPages = {
  ...OwFGrantLandingPageSections,
  ...OwFGrantApplicationSteps,
  ...OtherOwFGrantSurfaces,
};

export enum OwFGrantCtas {
  APPLY_NOW = "APPLY_NOW",
  GET_STARTED = "GET_STARTED",
  NEXT = "NEXT",
  SUBMIT_APPLICATION = "SUBMIT_APPLICATION",
  EXPLORE_FAIRE = "EXPLORE_FAIRE",
  START_BUYING = "START_BUYING",
}

export enum OwFGrantUserFlows {
  LOGGED_OUT_FLOW = "LOGGED_OUT_FLOW",
  LOGGED_IN_FLOW = "LOGGED_IN_FLOW",
  LOGGED_IN_APPLIED_TO_OWF_FLOW = "LOGGED_IN_APPLIED_TO_OWF_FLOW",
}
